import { useMutation, useQuery, useQueryClient } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function GroupsGet() {
  const { makeAuthedRequest } = Auth.useContainer();

  const { data, isError, isLoading, refetch } = useQuery(
    ["groups"],
    () =>
      makeAuthedRequest(`v1/events/groups`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    { staleTime: 0 }
  );

  return {
    data,
    isLoading,
    refetch,
  };
}
